import React from 'react'

const CollegeInfo = () => {
  return (
    <section className="bg-gray-100">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-4 w-full">
        <h3 className="text-3xl font-medium">Degree</h3>
        <p className="text-base md:text-lg lg:text-xl">
          After completing this program, You will be certified by us at Devsnest
          Tech School.
        </p>
        <p className="text-base md:text-lg lg:text-xl">
          You will receive BCA degree from Mysore University, Approved by UGC
          AICTE and accredited by NAAC.{' '}
        </p>
      </div>
    </section>
  )
}

export default CollegeInfo
